import React, { useEffect, useState } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Button, Container, Row } from 'react-bootstrap';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { Shimmer } from 'react-shimmer';

// Import assets
import whyImg from '../assets/images/why-img.svg';
import playImg from '../assets/images/play-img.svg';
import img1 from '../assets/images/img1.svg';
import img2 from '../assets/images/img2.svg';
import img3 from '../assets/images/img3.svg';
import step1 from '../assets/images/step11.png';
import step2 from '../assets/images/step12.png';
import step3 from '../assets/images/step13.png';
import stepBottomImg from '../assets/images/m.png';
import videoImg from '../assets/images/video-img.png';
import elevateImg from '../assets/images/elevate-bg2.png';
import checkIcon from '../assets/images/icon.png';
import featuresBg from '../assets/images/keynotes-bg.png';
import keynotesImg from '../assets/images/keynotes-img.png';
import testimonialBg from '../assets/images/bg-img.png';
import appBg from '../assets/images/download-bg.png';
import dwnRightImg from '../assets/images/download-img.png';
import dwn1 from '../assets/images/dwn1.png';
import dwn2 from '../assets/images/dwn2.png';
import element1 from '../assets/images/star-symbol.svg';

// Import components
import SectionHeading from './SectionHeading';
import ElevateSlider from './ElevateSlider';
import './ElevateSlider.css';
import VerticalSlider from './VerticalSlider';
import ClientTestimonial from './ClientTestimonial';
import './ClientTestimonial.css';
import TabContent from './TabContent';
import WhySlider from './WhySlider';
import StoryTestimonial from './StoryTestimonial';
import './StoryTestimonial.css';

//Import SVG Icons

import { WhyChooseSVG, WhyChoosePlaySVG, ElevateSVG, SmartFeaturesSVG, StudentTestimonialSVG, DownloadAppSVG, StarElementSVG } from '../components/SvgIcons';

import mobileBg from '../assets/images/mobileHand.png';
const steps = [
  {
    title: (
      <>
        Download App <br /> & Register
      </>
    ),
    img: step1,
    number: "01",
  },
  {
    title: (
      <>
        Verify Your <br /> Account
      </>
    ),
    img: step2,
    number: "02",
  },
  {
    title: (
      <>
        Start <br /> Using smart app
      </>
    ),
    img: step3,
    number: "03",
  },
];

const slideImages = [img1, img2, img3];

// =============== CHOOSE SECTION ===============
const ChooseSection = ({ sliders = [], sectionImage, playButtonImage = playImg, featureVideoUrl }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [playBtnLoaded, setPlayBtnLoaded] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const slideHeight = 575;
  const slidesToUse = sliders.length > 0 ? sliders : slideImages;
  const duplicatedSlides = [...slidesToUse, ...slidesToUse];

  const moveSlide = (direction) => {
    setCurrentSlide((prev) =>
      direction === 'up'
        ? prev === 0
          ? duplicatedSlides.length - 1
          : prev - 1
        : prev === duplicatedSlides.length - 1
          ? 0
          : prev + 1
    );
  };

  const sliderStyle = {
    transform: `translateY(-${currentSlide * slideHeight}px)`,
    transition: 'transform 0.3s ease-in-out',
  };

  // Extract YouTube video ID from the URL
  const getYouTubeVideoId = (url) => {
    if (!url) return '';
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    const match = url.match(regExp);
    return match && match[2].length === 11 ? match[2] : '';
  };

  const videoId = getYouTubeVideoId(featureVideoUrl);
  const embedUrl = videoId ? `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1` : '';

  const openModal = (e) => {
    e.preventDefault();
    if (videoId) setShowModal(true); // Only open modal if valid video ID
  };

  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <>
      <Row className="margin-50 align-items-center">
        <div className="col-sm-12 col-lg-6 vertical">
          <WhySlider sliders={sliders} />
        </div>

        <div className="col-sm-12 col-lg-6">
          <div className="choose-section">
            <div className="svg-position why-svg">
              <WhyChooseSVG />
              <div className="svg-content">
                <div className="imgee">
                  <img  src={sectionImage} alt="" />
                </div>
                <div className="whyplay-block">
                  <a className="popup-youtube icon-play" href="#" onClick={openModal}>
                    <WhyChoosePlaySVG />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Row>

      {/* React Modal */}
      {showModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            zIndex: 1050,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div className="modal-dialog modal-dialog-centered modal-xl">
            <div className="modal-content" style={{ background: 'transparent' }}>
              <div className="button-block text-end">
                <button type="button" className="btn-close" onClick={closeModal} aria-label="Close"></button>
              </div>
              <div className="modal-body p-0">
                <div className="video-container w-100">
                  <iframe
                    id="videoFrame"
                    src={embedUrl}
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    width="100%"
                    height="500"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

// =============== SECTION TITLE ===============
const SectionTitle = ({ webContent, isLoading, isError, error }) => {
  useEffect(() => {
    AOS.init({ once: true });
  }, []);

  // Extract features-section data
  const featuresSection = webContent?.dataset?.data?.['features-section']?.json_data;

  if (!featuresSection) {
    return null;
  }

  // Default static values for fallback
  const defaultData = {
    title: 'Why choose us',
    subtitle: 'MCQs, Notes, Tests & Lectures for All Competitive Exams',
    badgeText: 'Best features',
    sectionImage: whyImg,
    playButtonImage: playImg,
    featureVideoUrl: 'https://www.youtube.com/watch?v=tgbNymZ7vqY', // Fallback video URL
  };

  // Dynamic data from features-section
  const sectionData = {
    title: featuresSection?.title || defaultData.title,
    subtitle: featuresSection?.small_description || defaultData.subtitle,
    badgeText: featuresSection?.heading_text || defaultData.badgeText,
    sectionImage: featuresSection?.section_image || defaultData.sectionImage,
    playButtonImage: featuresSection?.play_button_image || defaultData.playButtonImage,
    featureVideoUrl: featuresSection?.feature_video_url || defaultData.featureVideoUrl,
  };

  // Handle loading and error states
  if (isLoading) {
    return (
      <section className="why-choose-block margin-custom">
        <Container>
          <div>Loading...</div>
        </Container>
      </section>
    );
  }

  if (isError) {
    return (
      <section className="why-choose-block margin-custom">
        <Container>
          <div>Error: {error?.message || 'Failed to load content'}</div>
        </Container>
      </section>
    );
  }

  return (
    <section className="why-choose-block margin-custom">
      <div className="element">
        <span className="element1">
          {/* <img src={element1} alt="Element 1" loading="lazy" /> */}
          <StarElementSVG />
        </span>
        <span className="element2">
          {/* <img src={element1} alt="Element 2" loading="lazy" /> */}
          <StarElementSVG />
        </span>
      </div>
      <Container>
        <SectionHeading
          title={sectionData.title}
          subtitle={sectionData.subtitle}
          badgeText={sectionData.badgeText}
        />
        <ChooseSection
          sliders={featuresSection?.sliders || []}
          sectionImage={sectionData.sectionImage}
          playButtonImage={sectionData.playButtonImage}
          featureVideoUrl={sectionData.featureVideoUrl}
        />
      </Container>
    </section>
  );
};

// =============== EASY STEPS SECTION ===============
const SectionTitleTwo = ({ webContent, isLoading, isError, error }) => {
  useEffect(() => {
    AOS.init({ once: true });
  }, []);

  // Extract easy-steps-section data
  const easyStepsSection = webContent?.dataset?.data?.['easy-steps-section']?.json_data;

  if (!easyStepsSection) {
    return null;
  }

  // Default static values for fallback
  const defaultData = {
    title: "3 Easy steps to start it",
    subtitle: "MCQs, Notes, Tests & Lectures for All Competitive Exams",
    badgeText: "EASY STEPS",
    sectionImage: stepBottomImg,
    steps: steps,
  };

  // Dynamic data from easy-steps-section
  const sectionData = {
    title: easyStepsSection?.title || defaultData.title,
    subtitle: easyStepsSection?.small_description || defaultData.subtitle,
    badgeText: easyStepsSection?.heading_text || defaultData.badgeText,
    sectionImage: easyStepsSection?.section_image || defaultData.sectionImage,
    steps: easyStepsSection?.steps || defaultData.steps,
  };

  // Format the dynamic steps data to match our component's expected format
  const dynamicSteps = sectionData.steps.map((step, index) => ({
    title: <>{step.title}</>,
    img: step.image || [step1, step2, step3][index % 3], // Fallback to static images if needed
    number: `0${index + 1}`,
    description: step.description,
  }));

  // Handle loading and error states
  if (isLoading) {
    return (
      <section className="why-choose-block margin-custom">
        <Container>
          <div>Loading...</div>
        </Container>
      </section>
    );
  }

  if (isError) {
    return (
      <section className="why-choose-block margin-custom">
        <Container>
          <div>Error: {error?.message || 'Failed to load content'}</div>
        </Container>
      </section>
    );
  }

  return (
    <section className="why-choose-block margin-custom">
      <div className="floating-dots">
        {[...Array(10)].map((_, i) => (
          <div className="dot" key={i}></div>
        ))}
      </div>

      <Container>
        <SectionHeading
          title={sectionData.title}
          subtitle={sectionData.subtitle}
          badgeText={sectionData.badgeText}
        />

        <div className="row margin-50">
          {dynamicSteps.map((step, index) => (
            <div className="col-md-6 col-lg-4" key={index}>
              <div className="bg-shadow bg-border border-box">
                <div className="d-flex justify-content-between steps-header">
                  <h4 className="text-heading mb-0">{step.title}</h4>
                  {isLoading ? (
                    <Shimmer width={100} height={100} />
                  ) : (
                    <img src={step.img} alt={`Step ${step.number}`} loading="lazy" />
                  )}
                </div>
                <p className="mb-0 margin-16 paragraph-text">{step.description}</p>
                <div className="step-number">
                  <div className="number">{step.number}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="row margin-50 steps-bottom-img text-center steps-header">
          {isLoading ? (
            <Shimmer width={250} height={250} />
          ) : (
            <img src={sectionData.sectionImage} className="animated-image" alt="" loading="lazy" />
          )}
        </div>
      </Container>
    </section>
  );
};

// =============== ELEVATE SECTION WITH SLIDER ===============
const ElevateSection = ({ webContent, isLoading, isError, error }) => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    AOS.init({ once: true });
  }, []);

  // Extract elevate-section data
  const elevateSection = webContent?.dataset?.data?.['elevate-section']?.json_data;

  if (!elevateSection) {
    return null;
  }

  // Default static values for fallback
  const defaultData = {
    title: "Elevate your growth",
    subtitle: "with our smart app",
    badgeText: "EASY STEPS",
    description:
      "Vidyakasam Education is an all-in-one platform for competitive exam preparation, offering MCQs, quizzes, notes, mock tests, and lectures for UPSC, State PSCs, AIAPGET, and more.",
    sectionImage: videoImg,
    videoUrl: "https://www.youtube.com/embed/tgbNymZ7vqY?autoplay=1&mute=1",
    sliders: [],
  };

  // Dynamic data from elevate-section
  const sectionData = {
    title: elevateSection?.title || defaultData.title,
    badgeText: elevateSection?.heading_text || defaultData.badgeText,
    description: elevateSection?.small_description || defaultData.description,
    sectionImage: elevateSection?.section_image || defaultData.sectionImage,
    videoUrl: elevateSection?.section_video_url || defaultData.videoUrl,
    sliders: elevateSection?.sliders || defaultData.sliders,
  };

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  // Handle loading and error states
  if (isLoading) {
    return (
      <section className="elevate-section">
        <Container>
          <div>Loading...</div>
        </Container>
      </section>
    );
  }

  if (isError) {
    return (
      <section className="elevate-section">
        <Container>
          <div>Error: {error?.message || 'Failed to load content'}</div>
        </Container>
      </section>
    );
  }

  return (
    <section
      className="elevate-section">
      <div className="svg-position svg-img">
        <ElevateSVG />
        <div className="elevate-svg svg-content">
          <div className="element">
            <span className="element3">
              {/* <img src={element1} alt="" loading="lazy" /> */}
              <StarElementSVG />

            </span>
            <span className="element4">
              <StarElementSVG />
              {/* <img src={element1} alt="" loading="lazy" /> */}
            </span>
          </div>
          <Container>
            <Row>
              <div className="col-md-5 col-lg-6">
                <div
                  className="section_title top_content elevate-heading"
                  data-aos="fade-up"
                  data-aos-duration="1500"
                  data-aos-delay="300"
                >
                  <span className="title_badge mb-1 text-background">
                    {sectionData.badgeText}
                  </span>
                  <h2 className="mb-0 text-white">{sectionData.title}</h2>
                </div>
              </div>
              <div className="col-md-7 col-lg-6">
                <div className="elvate-right">
                  <p
                    className="mb-0 paragraph-text text-white"
                    data-aos="fade-up"
                    data-aos-duration="1000"
                    data-aos-delay="100"
                  >
                    {sectionData.description}
                  </p>
                </div>
              </div>
            </Row>

            <Row className="margin-50 video-section">
              <div className="col-md-12 text-center">
                {isLoading ? (
                  <Shimmer width="100%" height={400} />
                ) : (
                  <img src={sectionData.sectionImage} className="video-img w-100" alt="" loading="lazy" />
                )}
                <button type="button" className="video-btn video-bg" onClick={openModal}>
                  <i className="fas fa-play"></i> WATCH VIDEO
                </button>
              </div>
            </Row>

            {/* React Modal */}
            {showModal && (
              <div
                className="modal fade show d-block"
                tabIndex="-1"
                style={{
                  backgroundColor: 'rgba(0, 0, 0, 0.8)',
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  width: '100vw',
                  height: '100vh',
                  zIndex: 1050,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <div className="modal-dialog modal-dialog-centered modal-xl">
                  <div className="modal-content" style={{ background: 'transparent' }}>
                    <div className="button-block text-end">
                      <button type="button" className="btn-close" onClick={closeModal} aria-label="Close"></button>
                    </div>
                    <div className="modal-body p-0">
                      <div className="video-container w-100">
                        <iframe
                          id="videoFrame"
                          src={sectionData.videoUrl}
                          title="YouTube video player"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                          width="100%"
                          height="500"
                        ></iframe>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="margin-50">
              <ElevateSlider sliders={sectionData.sliders} />
            </div>
          </Container>
        </div>
      </div>
    </section>
  );
};

// =============== SMART FEATURES OR KEY NOTES SECTION ===============
const FeatureSection = ({ webContent, isLoading, isError, error }) => {
  useEffect(() => {
    AOS.init({ once: true });
  }, []);

  // Extract key-notes-section data
  const keyNotesSection = webContent?.dataset?.data?.['key-notes-section']?.json_data;

  // Default static values for fallback
  const defaultData = {
    title: 'Smart Features',
    badgeText: 'KEY NOTES',
    sectionImage: keynotesImg,
    buttonText: 'Get started',
    buttonUrl: '#',
    sliders: [
      {
        title: 'GET STARTED',
        heading: 'GET STARTED HEAD',
        description:
          'Vidyakasam Education is an all-in-one platform for competitive exam preparation, offering MCQs, quizzes, notes, mock tests, and lectures for UPSC, State PSCs, AIAPGET, and more.',
      },
      {
        title: 'Expert Advisor',
        heading: 'Expert Advisor HEAD',
        description:
          'Vidyakasam Education is an all-in-one platform for competitive exam preparation, offering MCQs, quizzes, notes, mock tests, and lectures for UPSC, State PSCs, AIAPGET, and more.',
      },
      {
        title: 'Easy Process',
        heading: 'Easy Process',
        description:
          'Vidyakasam Education is an all-in-one platform for competitive exam preparation, offering MCQs, quizzes, notes, mock tests, and lectures for UPSC, State PSCs, AIAPGET, and more.',
      },
    ],
  };

  // Dynamic data from key-notes-section
  const sectionData = {
    title: keyNotesSection?.title || defaultData.title,
    badgeText: keyNotesSection?.heading_text || defaultData.badgeText,
    sectionImage: keyNotesSection?.section_image || defaultData.sectionImage,
    buttonText: keyNotesSection?.button_text || defaultData.buttonText,
    buttonUrl: keyNotesSection?.button_url || defaultData.buttonUrl,
    sliders: keyNotesSection?.sliders?.length > 0 ? keyNotesSection.sliders : defaultData.sliders,
  };

  const [activeText, setActiveText] = useState(sectionData.sliders[0]?.title || defaultData.sliders[0].title);
  const [imageLoaded, setImageLoaded] = useState(false);

  if (!keyNotesSection) {
    return null;
  }

  // Handle loading and error states
  if (isLoading) {
    return (
      <section className="keynotes-section">
        <Container>
          <div className="text-center">Loading...</div>
        </Container>
      </section>
    );
  }

  if (isError) {
    return (
      <section className="keynotes-section">
        <Container>
          <div className="text-center">Error: {error?.message || 'Failed to load content'}</div>
        </Container>
      </section>
    );
  }

  return (
    <section
      id="features"
      className="keynotes-section"
      data-aos="fade-up"
      data-aos-duration="1000"
      data-aos-offset="300"
      data-aos-easing="ease-in-out"
    >
      <Container className="keynotes-container">
        <div
          className="keynotes-bg svg-position svg-img">
          <SmartFeaturesSVG />
          <div className="keynotes-svg svg-content">
            <SectionHeading title={sectionData.title} badgeText={sectionData.badgeText} />

            <div className="row margin-50">
              <div className="col-md-4 col-lg-3" data-aos="fade-right" data-aos-delay="200">
                <VerticalSlider sliders={sectionData.sliders} setActiveText={setActiveText} />
              </div>
              <div className="col-md-8 col-lg-9">
                <Row className="tab-contentt getStarted">
                  <div className="col-md-6 col-lg-6" data-aos="fade-up" data-aos-delay="400">
                    <TabContent
                      sliders={sectionData.sliders}
                      activeText={activeText}
                      buttonText={sectionData.buttonText}
                      buttonUrl={sectionData.buttonUrl}
                    />
                  </div>
                  <div className="col-md-6 col-lg-6">
                    <div className="keynotes" style={{ position: 'relative' }}>
                      {isLoading ? (
                        <Shimmer width="100%" height={400} />
                      ) : (
                        <img
                          src={sectionData.sectionImage}
                          className=""
                          alt="Keynotes"
                          loading="lazy"
                          style={{ width: '100%', height: 'auto' }}
                        />
                      )}
                    </div>
                  </div>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

// =============== CLIENT TESTIMONIAL SECTION ===============
const ClientTestimonialSection = ({ webContent, isLoading, isError, error }) => {
  useEffect(() => {
    AOS.init({ once: true });
  }, []);

  // Extract reviews-section data
  const reviewsSection = webContent?.dataset?.data?.['reviews-section']?.json_data;

  if (!reviewsSection) {
    return null;
  }

  // Default static values for fallback
  const defaultData = {
    title: 'Client Testimonials',
    headingText: 'REVIEWS',
    smallDescription:
      'MCQs, Notes, Tests & Lectures for All Competitive Exams',
    buttonText: 'VIEW MORE TESTIMONIAL BUTTON',
    buttonUrl: '#',
    testimonials: [
      {
        description: 'Vidyakasam Education is an all-in-one platform for competitive exam preparation, offering MCQs, quizzes, notes, mock tests, and lectures for UPSC, State PSCs, AIAPGET, and more.',
      },
    ],
  };

  // Dynamic data from reviews-section
  const sectionData = {
    title: reviewsSection?.title || defaultData.title,
    headingText: reviewsSection?.heading_text || defaultData.headingText,
    buttonText: reviewsSection?.button_text || defaultData.buttonText,
    buttonUrl: reviewsSection?.button_url || defaultData.buttonUrl,
    testimonials: reviewsSection?.small_description
      ? [{ description: reviewsSection.small_description }]
      : defaultData.testimonials,
  };

  // Handle loading and error states
  if (isLoading) {
    return (
      <section className="testimonial-container">
        <Container>
          <div className="text-center">Loading...</div>
        </Container>
      </section>
    );
  }

  if (isError) {
    return (
      <section className="testimonial-container">
        <Container>
          <div className="text-center">Error: {error?.message || 'Failed to load content'}</div>
        </Container>
      </section>
    );
  }

  return (
    <section
      id="testimonials"
      className="testimonial-container">
      <div className="svg-position svg-img testimonialSVG">
        <StudentTestimonialSVG />
        <div className="svg-content">
          <div className="floating-dots">
            {[...Array(10)].map((_, i) => (
              <div className="dot" key={i}></div>
            ))}
          </div>

          <Container>
            <SectionHeading
              title={sectionData.title}
              subtitle={sectionData.testimonials[0]?.description}
              badgeText={sectionData.headingText}
            />

            <div className="row">
              <div className="col-md-12" data-aos="fade-up" data-aos-delay="200">
                <ClientTestimonial />
              </div>

              <div className="viewmore-btn text-center mt-4" data-aos="fade-up" data-aos-delay="400">
                <Button
                  as="a"
                  href={sectionData.buttonUrl}
                  className="get-btn"
                  style={{
                    padding: '12px 24px',
                    fontSize: '1rem',
                    fontWeight: 600,
                    textTransform: 'uppercase',
                  }}
                >
                  {sectionData.buttonText}
                </Button>
              </div>
            </div>
          </Container>
        </div>
      </div>
    </section>
  );
};

// =============== DOWNLOAD APP SECTION ===============
const DownloadAppSection = ({ webContent, isLoading, isError, error }) => {
  useEffect(() => {
    AOS.init({ once: true });
  }, []);

  // --- helpers ---
  const toAbsolute = (u) => {
    if (!u) return '';
    // keep as-is if already absolute
    if (/^(https?:)?\/\//i.test(u)) return u;
    // otherwise prefix with your CDN/base (set one of these in env) or leave as relative
    const base = process.env.REACT_APP_CDN_BASE || process.env.NEXT_PUBLIC_CDN_BASE || '';
    return base ? `${base.replace(/\/+$/, '')}/${String(u).replace(/^\/+/, '')}` : String(u);
  };

  // Raw CMS blob (what you showed in your JSON)
  const downloadAppSection =
    webContent?.dataset?.data?.['download-app-section']?.json_data;

  // --- defaults ---
  const defaultData = {
    title: 'Download app to manage customers',
    headingText: 'DOWNLOAD APP',
    smallDescription:
      'Vidyakasam Education is an all-in-one platform for competitive exam preparation, offering MCQs, quizzes, notes, mock tests, and lectures for UPSC, State PSCs, AIAPGET, and more.',
    sectionImage: dwnRightImg,
    buttons: [
      { url: '#', text: 'Download on App Store', image: dwn1 },
      { url: '#', text: 'Get on Google Play', image: dwn2 },
    ],
  };

  // --- normalize CMS buttons (object -> array) and sanitize fields ---
  const rawButtons = downloadAppSection?.buttons;
  const cmsButtonsArray = Array.isArray(rawButtons)
    ? rawButtons
    : rawButtons && typeof rawButtons === 'object'
      ? Object.values(rawButtons)
      : [];

  const normalizedButtons =
    cmsButtonsArray.map((b, i) => ({
      text: b?.text || defaultData.buttons[i]?.text || '',
      url: b?.url || defaultData.buttons[i]?.url || '#',
      image: toAbsolute(b?.image || b?.image_url || defaultData.buttons[i]?.image),
    })) || [];

  // --- build section data using CMS with safe fallbacks ---
  const sectionData = {
    title: downloadAppSection?.title || defaultData.title,
    headingText: downloadAppSection?.heading_text || defaultData.headingText,
    smallDescription:
      downloadAppSection?.small_description || defaultData.smallDescription,
    sectionImage: toAbsolute(
      downloadAppSection?.section_image || downloadAppSection?.existing_section_image
    ) || defaultData.sectionImage,
    buttons: normalizedButtons.length ? normalizedButtons : defaultData.buttons,
  };

  const [imageLoaded, setImageLoaded] = useState(false);

  if (!downloadAppSection) {
    return null;
  }

  if (isLoading) {
    return (
      <section className="download-app">
        <Container><div className="text-center">Loading...</div></Container>
      </section>
    );
  }

  if (isError) {
    return (
      <section className="download-app">
        <Container><div className="text-center">Error: {error?.message || 'Failed to load content'}</div></Container>
      </section>
    );
  }

  return (
    <section
      id="download_app"
      className="download-app"
      data-aos="fade-up"
      data-aos-duration="1000"
      data-aos-offset="300"
      data-aos-easing="ease-in-out"
    >
      <Container className="download-container">
        <div className="svg-position svg-img">
          <DownloadAppSVG />
          <div className="download-content svg-content">
            <div className="element">
              <span className="element1"><StarElementSVG /></span>
              <span className="element2"><StarElementSVG /></span>
            </div>

            <Row className="align-items-center">
              <div className="col-md-6" data-aos="fade-right" data-aos-delay="200">
                <div className="keynotes-section">
                  <SectionHeading
                    title={sectionData.title}
                    subtitle={sectionData.smallDescription}
                    badgeText={sectionData.headingText}
                  />
                  <div className="app-buttons dwn-btns">
                    {sectionData.buttons.map((button, idx) => (
                      <a
                        key={`button-${idx}`}
                        href={button.url}
                        className="app-btn me-2"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img src={button.image} alt={button.text || 'Download'} loading="lazy" />
                      </a>
                    ))}
                  </div>
                </div>
              </div>

              <div className="col-md-6" data-aos="fade-left" data-aos-delay="400">
                <div className="download-img" style={{ position: 'relative' }}>
                  {!imageLoaded && <Shimmer width="100%" height={400} />}
                  <img
                    src={sectionData.sectionImage}
                    alt="Download Vidyakasam App"
                    loading="lazy"
                    onLoad={() => setImageLoaded(true)}
                    onError={() => setImageLoaded(true)}
                    style={{ width: '100%', height: 'auto', display: imageLoaded ? 'block' : 'block' }}
                  />
                </div>
              </div>
            </Row>
          </div>
        </div>
      </Container>
    </section>
  );
};

// =============== LATEST STORY TESTIMONIAL SECTION ===============
const StoryTestimonialSection = ({ webContent, isLoading, isError, error }) => {
  useEffect(() => {
    AOS.init({ once: true });
  }, []);

  // Extract blogs-section data
  const blogsSection = webContent?.dataset?.data?.['blogs-section']?.json_data;

  // Default static values for fallback
  const defaultData = {
    title: 'Read latest story',
    headingText: 'BLOG POST',
    smallDescription:
      'MCQs, Notes, Tests & Lectures for All Competitive Exams',
  };


  if (!blogsSection) {
    return null;
  }

  // Dynamic data from blogs-section
  const sectionData = {
    title: blogsSection?.title || defaultData.title,
    headingText: blogsSection?.heading_text || defaultData.headingText,
    smallDescription: blogsSection?.small_description || defaultData.smallDescription,
  };

  return (
    <section className="latest-story">
      <Container>
        <SectionHeading
          title={sectionData.title}
          subtitle={sectionData.smallDescription}
          badgeText={sectionData.headingText}
        />

        <div className="row">
          <div className="col-md-12">
            <StoryTestimonial />
          </div>
        </div>
      </Container>
    </section>
  );
};

// =============== MAIN EXPORT ===============
export default function HomeSections({ webContent, isLoading, isError, error }) {
  return (
    <>
      <SectionTitle webContent={webContent} isLoading={isLoading} isError={isError} error={error} />
      <SectionTitleTwo webContent={webContent} isLoading={isLoading} isError={isError} error={error} />
      <ElevateSection webContent={webContent} isLoading={isLoading} isError={isError} error={error} />
      <FeatureSection webContent={webContent} isLoading={isLoading} isError={isError} error={error} />
      <ClientTestimonialSection webContent={webContent} isLoading={isLoading} isError={isError} error={error} />
      <DownloadAppSection webContent={webContent} isLoading={isLoading} isError={isError} error={error} />
      <StoryTestimonialSection webContent={webContent} isLoading={isLoading} isError={isError} error={error} />
    </>
  );
}


